<template>
  <div class="registControllers">
    <app-loading class="registControllers__loading" :isLoading="isLoading"></app-loading>
    <form
      :method="method"
      :action="action"
      ref="form"
      novalidate="true">
      <input type="hidden" name="cpno" :value="cpno">
      <input type="hidden" name="_token" :value="token">
      <p v-if="!fromOrder" class="registControllers__step">ステップ1/2</p>
      <h1 class="registControllers__title">{{fromOrder ? 'アカウント情報を登録' : '占いTVに登録（月額528円）'}}</h1>
      <Attention v-if="errorMessage" :text="errorMessage"/>
      <form-input
        v-model="email"
        type="email"
        name="email"
        placeholder="例）uranaitv@uranai.tv"
        label="メールアドレス"
        class="input-email"
        :validation="{ rules: {
          required: true,
          email: false,
          nonRfcEmailCheck: true,
          duplicateEmail: true,
          max: 100
          } }"
      />
      <form-password
        v-model="password"
        name="password"
        placeholder=""
        label="パスワード"
        class="input-password"
        :autosave="false"
        :validation="{ rules: {
          required: true,
          max: 30,
          min: 8,
          passCheck2: true,
          passCheck1: true
          } }"
        :strength-meter="false"
      />
      <div class="registControllers__passAttention">※半角英字・数字の組み合わせ8文字以上（記号も使えます）</div>
      <div class="registControllers__check">
      <base-checkbox
        name="terms"
        :value="terms"
        :isChecked="terms"
        :validation="{ rules: {required: true,} }"
        @change="terms = !terms"
      >
        <a href="/terms" target="_blank">利用規約</a>と
        <a href="/privacy" target="_blank">プライバシーポリシー</a>に同意します
      </base-checkbox>
      </div>
      <BaseButton
        class="registControllers__button"
        label="お支払い情報入力へ"
        :is-disabled="buttonIsDisabled"
        @clicked="regist"/>
      <div class="registControllers__sns">
        <p class="registControllers__sns__title">SNSアカウントで登録</p>
        <sns-register
          register-type="signup"
          :registToken="registToken"
        ></sns-register>
      </div>
      <div class="registControllers__new">
        すでにアカウントをお持ちの方は<a href="/user/login?subsc_regist=1">ログイン</a>
      </div>
    </form>

    <SubscDescription :subsc-price="528" :is-subsc-regist="true" v-if="!fromOrder" />

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'
import Attention from './common/Attention'
import BaseButton from './common/BaseButton'
import BaseCheckbox from './common/BaseCheckbox'
import SubscDescription from './SubscDescription'

export default {
  name: 'registControllers',
  components:{
    Attention,
    BaseButton,
    BaseCheckbox,
    SubscDescription,
  },
  data() {
    return {
      cpno: window.Laravel.cpno,
      token: window.Laravel.csrfToken,
      email: '',
      password: '',
      terms: false,
      errorMessage:'',
      registData: {},
      validateFlags: {},
      buttonIsDisabled: true,
      isLoading:false
    }
  },
  props: {
    registToken: { type: String, default: ''},
    action: { type: String, default: ''},
    method: { type: String, default: ''},
    fromOrder: { type: Number, default: 0},
  },
  watch:{
    validateFlags: {
      handler(n) {
        this.buttonIsDisabled = n.email.invalid || n.password.invalid || n.terms.invalid
      },
      deep: true
    }
  },
  mounted(){
    this.validateFlags = this.$validator.flags
  },
  methods: {
     regist() {
      this.isLoading = true
      this.$validator.validateAll().then(res => {
        if (!res) {
          this.isLoading = false
          return false
        }else {
          this.$refs.form.submit()
        }
      })
    }
  }
}</script>

<style lang="scss">
@import "../../../sass/commons/commonVariables.scss";

.registControllers{
  padding: 40px 30px;
  color: $col_base_black;
  max-width: 580px;
  margin: auto;

  &__step{
    font-weight: bold;
    font-size: 11px;
    text-align: center;
    margin: 0;
    &::after {
      content: '';
      display: block;
      width: 15px;
      height: 2px;
      margin: 5px auto 0;
      background: linear-gradient(65.54deg, $col_temp_key1 21.4%, $col_temp_key2 76.64%);
    }
  }

  &__title{
    font-size: 21px;
    line-height: 31px;
    text-align: center;
    margin: 2px 0 20px;
  }

  &__passAttention{
    font-size: 11px;
  }

  &__check{
    color: $col_normal_font;
    font-size: 11px;
    margin: 20px auto 0;
    width: fit-content;
  }

  &__button{
    margin: 20px auto;
  }
  .baseButton__button {
    width: 100%;
  }

  &__sns{
    &__title{
      font-size: 13px;
      line-height: 19px;
      text-align: center;
      display: flex;
      align-items: center;
    }

    &__title:before,
    &__title:after {
      content: "";
      flex-grow: 1;
      height: 1px;
      background: $col_temp_gray2;
      display: block;
    }
    &__title:before {
      margin-right: 0.6em;
    }
    &__title:after {
      margin-left: 0.6em;
    }
  }

  &__new{
    font-weight: bold;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    color: $col_temp_black;
    margin: 20px -5px 0;
  }

   &__loading {
    position: absolute;
    z-index: 3;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .baseCheckBox__label {
    flex-wrap: wrap;
    font-size: 11px;
    line-height: 18px;
    margin: 0 -5px;
    &::before {
      top: -3px;
      left: -6px;
      height: 25px;
      width: 25px;
    }
    &::after {
      width: 8px;
      height: 13px;
      left: 3px;
      top: 8px!important;
    }
  }
}

.subscDescriptionWrap {
  margin-top: 20px;
}

.form-input {
  margin-bottom: 12px !important;
}
.form-password {
  margin-bottom: 8px !important;
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/RegistControllers.vue